import { useState, useEffect } from "react";
import "./header.css";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "Process", href: "#process" },
  { label: "FAQ", href: "#faq" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close the menu automatically if the viewport grows back to desktop size
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 860) setIsOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <header className="navbar">
      <div className="navbar__inner">
        <a href="#top" className="navbar__brand" onClick={() => setIsOpen(false)}>
          <span className="navbar__logo-mark">S</span>
          <span className="navbar__brand-text">
            <span className="navbar__brand-name">Strategic Accounting</span>
            <span className="navbar__brand-tag">Management &middot; Houston</span>
          </span>
        </a>

        <nav className="navbar__links navbar__links--desktop" aria-label="Primary">
          {NAV_LINKS.map((link) => (
            <a key={link.label} href={link.href} className="navbar__link">
              {link.label}
            </a>
          ))}
        </nav>

        <a href="#consultation" className="navbar__cta navbar__cta--desktop">
          Free Consultation
          <span className="navbar__cta-arrow" aria-hidden="true">
            &rarr;
          </span>
        </a>

        <button
          type="button"
          className={`navbar__toggle ${isOpen ? "is-open" : ""}`}
          aria-label={isOpen ? "Close menu" : "Open menu"}
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          onClick={() => setIsOpen((open) => !open)}
        >
          <span />
          <span />
          <span />
        </button>
      </div>

      <div
        id="mobile-menu"
        className={`navbar__mobile-menu ${isOpen ? "is-open" : ""}`}
      >
        <nav className="navbar__links navbar__links--mobile" aria-label="Mobile">
          {NAV_LINKS.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="navbar__link"
              onClick={() => setIsOpen(false)}
            >
              {link.label}
            </a>
          ))}
        </nav>
        <a
          href="#consultation"
          className="navbar__cta navbar__cta--mobile"
          onClick={() => setIsOpen(false)}
        >
          Free Consultation
          <span className="navbar__cta-arrow" aria-hidden="true">
            &rarr;
          </span>
        </a>
      </div>
    </header>
  );
}